import { config } from "../config";
import { Http } from "./http";

export const apiRequest = new Http(config.API_URL);
export const assetsApiRequest = new Http(config.ASSETS_API_URL);
